import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getServiceRecordDetails } from 'modules/activityDetails/ServiceRecordDetails/api/serviceRecordDetailsService'
import { ServiceRecordDetailsState, ApiServiceRecordDetailsResponse } from './types'

const initialState: ServiceRecordDetailsState = {
  serviceRecordDetailsData: {},
}

const serviceRecordDetailsSlice = createSlice({
  name: 'serviceRecordDetails',
  initialState,
  reducers: {
    serviceRecordDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiServiceRecordDetailsResponse>>
    ) {
      state.serviceRecordDetailsData = action.payload
    },
    clearServiceRecordDetails(state) {
      state.serviceRecordDetailsData = initialState.serviceRecordDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { serviceRecordDetailsLoaded, clearServiceRecordDetails } = serviceRecordDetailsSlice.actions

export { clearServiceRecordDetails }
export default serviceRecordDetailsSlice.reducer

export const loadServiceRecordDetailsData = (
  competenceId: Guid,
  serviceRecordId: Guid,
  resultId?: Guid
) => {
  return createApiAction({
    apiCalls: {
      serviceRecordDetails: () => getServiceRecordDetails(competenceId, serviceRecordId, resultId),
    },
    payloadAction: serviceRecordDetailsLoaded,
    getResultToKeep: state => state.serviceRecordDetails.serviceRecordDetailsData.result,
  })
}
